<div class="branding-layout">
  <div class="tab-content">
    <div class="intro-text">
      <span class="body-2">Your logo and colors will appear when your team shares files or folders
        through links. <a class="link" href="https://help.sync.com/hc/en-us/articles/38460570996883-Customizing-Sync-branding-with-your-own-logo" target="_blank">Learn more</a></span>
    </div>
    <sync-alert *ngIf="showAlert" [type]="'critical'" [leadIcon]="'error'" [showLeadIcon]="true" [title]="
        'The uploaded file type could not be used. Acceptable file types include JPG, PNG, GIF, and SVG files.'
      " [description]="''" [showActions]="false" [primaryButtonConfig]="{ label: 'Action' }"
      [showPrimaryAction]="false" [secondaryButtonConfig]="{ label: 'Action' }" [showSecondaryAction]="false"
      [showCloseButton]="false"></sync-alert>

    <div class="showsavealert">
      <sync-alert *ngIf="showAlertForSave" [type]="'critical'" [leadIcon]="'error'" [showLeadIcon]="true"
        [title]="'Please upload a logo to save your changes.'" [description]="''" [showActions]="false"
        [primaryButtonConfig]="{ label: 'Action' }" [showPrimaryAction]="false"
        [secondaryButtonConfig]="{ label: 'Action' }" [showSecondaryAction]="false"
        [showCloseButton]="false"></sync-alert>
    </div>
    <sync-spinner *ngIf="isFileLoading && !isFileUploaded"></sync-spinner>
    <sync-upload *ngIf="!isFileLoading || isFileUploaded" [showRemoveButton]="showRemoveLogoButton"
      [showUploadButton]="true" [uploadButtonConfig]="{
                label: 'Browse files', 
                size: 'medium', 
                color: 'default', 
                type: 'outlined', 
                leadAdornment: true, 
                leadIconAdornment: 'upload',
            }" [removeButtonConfig]="{
                label: 'Remove Logo', 
                size: 'medium', 
                color: 'default', 
                type: 'flat', 
                leadAdornment: false, 
                leadIconAdornment: '', 
            }" [primaryText]="isSmallScreen?'Upload your logo':'Drag and drop your logo here'" [subText1]="'PNG at 400 x 150 pixels recommended.'"
            [isDisplayOr]="isSmallScreen ? false : true"
      [subText2]="'A logo is required to change your branding.'" [isPreviewFile]="true" [isDragAndDrop]="true" 
      
      [onUpload]="uploadFile" [isMultiple]="false" [imageUrl]="imageUrl ? 'data:image/png;base64,' + imageUrl : ''"
      [fileTypes]="AllowedFileTypes"
      [imageStyle]="{ width: 400, height: 150 }">
    </sync-upload>

    <!-- Color Picker Button Template-->
    <ng-template #ColorPickerButtons>
      <div class="actions">
        <sync-button [type]="'flat'" [label]="'Cancel'" [disabled]="false" [isLoading]="false" [leadAdornment]="false"
          [trailAdornment]="false" [leadIconAdornment]="''" [trailIconAdornment]="''"
          [onClick]="onCancelButtonClick"></sync-button>
        <sync-button [type]="'flat'" [label]="'Confirm'" [disabled]="false" [isLoading]="false" [leadAdornment]="false"
          [trailAdornment]="false" [leadIconAdornment]="''" [trailIconAdornment]="''"
          [onClick]="onConfirmButtonClick"></sync-button>
      </div>
    </ng-template>

    <div class="color-options">
      <div class="color-list">
        <!--Color Picker Template-->
        <ng-template #HeaderColorTemplateColorPicker>
          <span [style.background]="selectedColor" [cpToggle]="true" [cpDialogDisplay]="'inline'"
            [(colorPicker)]="selectedColor"  [cpWidth]="cpWidth" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'" ></span>
        </ng-template>

        <!--Menu Template-->
        <ng-template #HeaderColorTemplate>
          <div>Header color</div>
          <sync-menu *ngIf="isHeaderColorTemplate && !isSmallScreen" [hasBackdrop]="false" [size]="'default'"
            (onClose)="isHeaderColorTemplate = false">
            <div class="color-menu">
              <div (click)="$event.stopPropagation();">
                <sync-section-header [header]="'Choose color'"
                  [description]="'Colors will appear when your team shares files or folders'" [level]="'subtitle'">
                </sync-section-header>
                <ng-container [ngTemplateOutlet]="HeaderColorTemplateColorPicker"></ng-container>
                <ng-container [ngTemplateOutlet]="ColorPickerButtons"></ng-container>
              </div>
            </div>
          </sync-menu>
        </ng-template>

        <!--Color Picker model for small screen-->
        <sync-dialog *ngIf="isSmallScreen" [config]="{
                        title: 'Choose color',
                        isClosable: false,
                        actionButton: 'Confirm',
                        cancelButton: 'Cancel',
                        onActionClick: onConfirmButtonClick,
                        onCancelClick: onCancelButtonClick,
                        isButtonLoading: isLoading,
                      }" [open]="isHeaderColorDialogOpen" [isFullScreen]="true">
          <div (click)="$event.stopPropagation();">
            <span class="body-2">Colors will appear when your team shares files or folders</span>
            <ng-container [ngTemplateOutlet]="HeaderColorTemplateColorPicker"></ng-container>
          </div>
        </sync-dialog>

        <sync-list [ListItems]="[{
                            primaryText: 'Header color', 
                            divider: false,
                            isInteractive: true,
                            leadAdornmentConfig: {
                                enabled: true, 
                                type: 'avatar', 
                                size: 'large', 
                                avatarConfig: {
                                    type: 'color', 
                                    size: 32,
                                    color: headerColor
                                }
                            },
                            onClick:onHeaderColorClick,
                            templateRef:HeaderColorTemplate
                        }]">
        </sync-list>
      </div>
      <div class="color-list">
        <!--Color Picker Template-->
        <ng-template #HeaderTextColorTemplateColorPicker>
          <span [style.background]="selectedColor" [cpToggle]="true" [cpDialogDisplay]="'inline'"
            [(colorPicker)]="selectedColor"  [cpWidth]="cpWidth"  [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"></span>
        </ng-template>

        <!--Menu Template-->
        <ng-template #HeaderTextColorTemplate>
          <div>Header text color</div>
          <sync-menu *ngIf="isHeaderTextColorTemplate && !isSmallScreen" [hasBackdrop]="false" [size]="'default'"
            (onClose)="isHeaderTextColorTemplate = false">
            <div class="color-menu">
              <div (click)="$event.stopPropagation();">
                <sync-section-header [header]="'Choose color'"
                  [description]="'Colors will appear when your team shares files or folders'" [level]="'subtitle'">
                </sync-section-header>
                <ng-container [ngTemplateOutlet]="HeaderTextColorTemplateColorPicker"></ng-container>
                <ng-container [ngTemplateOutlet]="ColorPickerButtons"></ng-container>
              </div>
            </div>
          </sync-menu>
        </ng-template>

        <!--Color Picker model for small screen-->
        <sync-dialog *ngIf="isSmallScreen" [config]="{
                        title: 'Choose color',
                        isClosable: false,
                        actionButton: 'Confirm',
                        cancelButton: 'Cancel',
                        onActionClick: onConfirmButtonClick,
                        onCancelClick: onCancelButtonClick,
                        isButtonLoading: isLoading,
                      }" [open]="isHeaderTextColorDialogOpen" [isFullScreen]="true">
          <div (click)="$event.stopPropagation();">
            <span class="body-2">Colors will appear when your team shares files or folders</span>
            <ng-container [ngTemplateOutlet]="HeaderTextColorTemplateColorPicker"></ng-container>
          </div>
        </sync-dialog>

        <sync-list [ListItems]="[{
                            primaryText: 'Header text color', 
                            divider: false, 
                            isInteractive: true,
                            leadAdornmentConfig: {
                                enabled: true, 
                                type: 'avatar', 
                                size: 'large', 
                                avatarConfig: {
                                    type: 'color', 
                                    size: 32,
                                    color: headerTextColor,
                                }
                            },
                            onClick:onHeaderTextColorClick,
                            templateRef:HeaderTextColorTemplate
                        }]">
        </sync-list>
      </div>
      <div class="color-list">
        <!--Color Picker Template-->
        <ng-template #LinkTextColorTemplateColorPicker>
          <span [style.background]="selectedColor" [cpToggle]="true" [cpDialogDisplay]="'inline'"
            [(colorPicker)]="selectedColor"  [cpWidth]="cpWidth"  [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"></span>
        </ng-template>

        <!--Menu Template-->
        <ng-template #LinkTextColorTemplate>
          <div>Link text color</div>
          <sync-menu *ngIf="isLinkTextColorTemplate && !isSmallScreen" [hasBackdrop]="false" [size]="'default'"
            (onClose)="isLinkTextColorTemplate = false">
            <div class="color-menu">
              <div (click)="$event.stopPropagation();">
                <sync-section-header [header]="'Choose color'"
                  [description]="'Colors will appear when your team shares files or folders'" [level]="'subtitle'">
                </sync-section-header>
                <ng-container [ngTemplateOutlet]="LinkTextColorTemplateColorPicker"></ng-container>
                <ng-container [ngTemplateOutlet]="ColorPickerButtons"></ng-container>
              </div>
            </div>
          </sync-menu>

        </ng-template>
        <!--Color Picker model for small screen-->
        <sync-dialog *ngIf="isSmallScreen" [config]="{
                        title: 'Choose color',
                        isClosable: false,
                        actionButton: 'Confirm',
                        cancelButton: 'Cancel',
                        onActionClick: onConfirmButtonClick,
                        onCancelClick: onCancelButtonClick,
                        isButtonLoading: isLoading,
                      }" [open]="isLinkTextColorDialogOpen" [isFullScreen]="true">
          <div (click)="$event.stopPropagation();">
            <span class="body-2">Colors will appear when your team shares files or folders</span>
            <ng-container [ngTemplateOutlet]="LinkTextColorTemplateColorPicker"></ng-container>
          </div>
        </sync-dialog>
        <sync-list [ListItems]="[{
                            primaryText: 'Link text color', 
                            divider: false, 
                            isInteractive: true,
                            leadAdornmentConfig: {
                                enabled: true, 
                                type: 'avatar', 
                                size: 'large', 
                                avatarConfig: {
                                    type: 'color', 
                                    size: 32,
                                    color: linkTextColor,
                                }
                            },
                            onClick:onLinkColorClick,
                            templateRef:LinkTextColorTemplate
                        }]">
        </sync-list>
      </div>
      <div class="color-list">
        <!--Color Picker Template-->
        <ng-template #ButtonPrimaryColorTemplateColorPicker>
          <span [style.background]="selectedColor" [cpToggle]="true" [cpDialogDisplay]="'inline'"
            [(colorPicker)]="selectedColor"  [cpWidth]="cpWidth" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"></span>
        </ng-template>
        <!--Menu Template-->
        <ng-template #ButtonPrimaryColorTemplate>
          <div>Button color</div>
          <sync-menu *ngIf="isButtonPrimaryColorTemplate && !isSmallScreen" [hasBackdrop]="false" [size]="'default'"
            (onClose)="isButtonPrimaryColorTemplate = false">
            <div class="color-menu">
              <div (click)="$event.stopPropagation();">
                <sync-section-header [header]="'Choose color'"
                  [description]="'Colors will appear when your team shares files or folders'" [level]="'subtitle'">
                </sync-section-header>
                <ng-container [ngTemplateOutlet]="ButtonPrimaryColorTemplateColorPicker"></ng-container>
                <ng-container [ngTemplateOutlet]="ColorPickerButtons"></ng-container>
              </div>
            </div>
          </sync-menu>
        </ng-template>
        <!--Color Picker model for small screen-->
        <sync-dialog *ngIf="isSmallScreen" [config]="{
              title: 'Choose color',
              isClosable: false,
              actionButton: 'Confirm',
              cancelButton: 'Cancel',
              onActionClick: onConfirmButtonClick,
              onCancelClick: onCancelButtonClick,
              isButtonLoading: isLoading,
            }" [open]="isButtonPrimaryColorDialogOpen" [isFullScreen]="true">
          <div (click)="$event.stopPropagation();">
            <span class="body-2">Colors will appear when your team shares files or folders</span>
            <ng-container [ngTemplateOutlet]="ButtonPrimaryColorTemplateColorPicker"></ng-container>
          </div>
        </sync-dialog>
        <sync-list [ListItems]="[{
                            primaryText: 'Button color', 
                            divider: false, 
                            isInteractive: true,
                            leadAdornmentConfig: {
                                enabled: true, 
                                type: 'avatar', 
                                size: 'large', 
                                avatarConfig: {
                                    type: 'color', 
                                    size: 32,
                                    color: buttonPrimaryColor,
                                }
                            },
                            onClick:onButtonPrimaryColorClick,
                            templateRef:ButtonPrimaryColorTemplate
                        }]">
        </sync-list>
      </div>
      <div class="color-list">
        <!--Color Picker Template-->
        <ng-template #ButtonTextColorTemplateColorPicker>
          <span [style.background]="selectedColor" [cpToggle]="true" [cpDialogDisplay]="'inline'"
            [(colorPicker)]="selectedColor"  [cpWidth]="cpWidth" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"></span>
        </ng-template>
        <!--Menu Template-->
        <ng-template #ButtonTextColorTemplate>
          <div>
            Button text color
          </div>
          <sync-menu *ngIf="isButtonTextColorTemplate && !isSmallScreen" [hasBackdrop]="false" [size]="'default'"
            (onClose)="isButtonTextColorTemplate = false">
            <div class="color-menu">
              <div (click)="$event.stopPropagation();">
                <sync-section-header [header]="'Choose color'"
                  [description]="'Colors will appear when your team shares files or folders'" [level]="'subtitle'">
                </sync-section-header>
                <ng-container [ngTemplateOutlet]="ButtonTextColorTemplateColorPicker"></ng-container>
                <ng-container [ngTemplateOutlet]="ColorPickerButtons"></ng-container>
              </div>
            </div>
          </sync-menu>
        </ng-template>
        <!--Color Picker model for small screen-->
        <ng-container>
          <sync-dialog [config]="{
              title: 'Choose color',
              isClosable: false,
              actionButton: 'Confirm',
              cancelButton: 'Cancel',
              onActionClick: onConfirmButtonClick,
              onCancelClick: onCancelButtonClick,
              isButtonLoading: isLoading,
          }" [open]=" isSmallScreen && isButtonTextColorDialogOpen" [isFullScreen]="true">
            <div (click)="$event.stopPropagation();">
              <span class="body-2">Colors will appear when your team shares files or folders</span>
              <ng-container [ngTemplateOutlet]="ButtonTextColorTemplateColorPicker"></ng-container>
            </div>
          </sync-dialog>
        </ng-container>
        <sync-list [ListItems]="[{
                            primaryText: 'Button text color', 
                            divider: false, 
                            isInteractive: true,
                            leadAdornmentConfig: {
                                enabled: true, 
                                type: 'avatar', 
                                size: 'large', 
                                avatarConfig: {
                                    type: 'color', 
                                    size: 32,
                                    color: buttonTextColor
                                }
                            },
                            onClick:onButtonTextColorClick,
                            templateRef:ButtonTextColorTemplate
                        }]">
        </sync-list>
      </div>
    </div>
    <div class="action-row">
      <sync-button [type]="'outlined'" [label]="'Reset to default'" [size]="'large'" [disabled]="false" [isLoading]="false"
        [leadAdornment]="false" [trailAdornment]="false" [onClick]="onResetDefaultClick"></sync-button>
      <div class="trail-button">
        <sync-button [type]="'outlined'" [label]="'Preview'" [size]="'large'" [disabled]="false" [isLoading]="false"
          [leadAdornment]="false" [trailAdornment]="false" [onClick]="onPreviewClick"></sync-button>
        <sync-button [type]="'filled'" [label]="'Save Changes'" [size]="'large'" [disabled]="false" [isLoading]="false"
          [leadAdornment]="false" [trailAdornment]="false" [onClick]="onSaveChangesClick"></sync-button>
      </div>
    </div>
  </div>

  <!-- User can preview changes Start  -->
  <div class="preview-dialog">
    <sync-dialog [config]="{title:'Preview',cancelButton:'Close', onCancelClick:onCancelClick, }" [open]="isPreviewDialog"
      [onClose]="onCloseClick" [isFullScreen]="isFullScreen">
      <div class="preview-save-body">
          <div class="body">
            The logos and colours below will appear when your team shares files or folders.
          </div>
        <div class="dp-02 brandingpreview">
          <div class="appbar">
            <sync-app-bar [leadIcon]="" [showLeadIcon]="false" [customBackgroundColor]="headerColor"
              [customTextColor]="headerTextColor" [heading]="'Header Text'" [showSecondaryText]="false"
              [secondaryText]="'Secondary Text Info'" [prominent]="false" [imageUrl]="'data:image/png;base64,'+imageUrl"></sync-app-bar>
          </div>
          <div class="file-content">
            <div class="buttons">
              <div class="sample-buttons">
                <sync-button [type]="'filled'" [size]="'large'" [label]="'Sample button'" [disabled]="false" [isLoading]="false"
                  [leadAdornment]="false" [trailAdornment]="false" [customColor]="buttonPrimaryColor" [customTextColor]="buttonTextColor"></sync-button>
                <sync-button [type]="'outlined'" [size]="'large'" [label]="'Sample button'" [disabled]="false" [isLoading]="false"
                  [leadAdornment]="false" [trailAdornment]="false" [customColor]="buttonPrimaryColor" [customTextColor]="buttonPrimaryColor"></sync-button>
              </div>
              <div class="sample-buttons-link">
                <sync-button [type]="'flat'" [size]="'large'" [label]="'Sample button'" [disabled]="false" [isLoading]="false"
                [leadAdornment]="false" [trailAdornment]="false" [customColor]="buttonPrimaryColor" [customTextColor]="buttonPrimaryColor"></sync-button>
                <a href="" class="sample-link" [style.color]="linkTextColor">Sample Link</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </sync-dialog>
  </div>
  <!-- User can preview changes End -->

  <!-- User can save changes Start  -->
  <div class="saveChanges-dialog">
    <sync-dialog [config]="{
      title: 'Save changes',
      actionButton: 'Save',
      cancelButton: 'Cancel',
      onCancelClick: onCancelClick,
      onActionClick: onSaveClick,
      isClosable: false
    }" [open]="isSaveChangesDialog" [onClose]="onCloseClick" [isFullScreen]="isFullScreen">
      <div class="preview-save-body">
        <div class="body">
          The logos and colours below will appear when your team shares files or folders.
        </div>
        <div class="dp-02 brandingpreview">
          <div class="appbar">
            <sync-app-bar [leadIcon]="" [showLeadIcon]="false" [customBackgroundColor]="headerColor"
              [customTextColor]="headerTextColor" [heading]="'Header Text'" [showSecondaryText]="false"
              [secondaryText]="'Secondary Text Info'" [prominent]="false" [imageUrl]="'data:image/png;base64,'+imageUrl"></sync-app-bar>
          </div>
          <div class="file-content">
            <div class="buttons">
              <div class="sample-buttons">
                <sync-button [type]="'filled'" [label]="'Sample button'" [size]="'large'" [disabled]="false" [isLoading]="false"
                  [leadAdornment]="false" [trailAdornment]="false" [customColor]="buttonPrimaryColor" [customTextColor]="buttonTextColor"></sync-button>
                <sync-button [type]="'outlined'" [label]="'Sample button'" [size]="'large'" [disabled]="false" [isLoading]="false"
                  [leadAdornment]="false" [trailAdornment]="false" [customColor]="buttonPrimaryColor" [customTextColor]="buttonPrimaryColor"></sync-button>
              </div>
              <div class="sample-buttons-link">
                <sync-button [type]="'flat'" [label]="'Sample button'" [size]="'large'" [disabled]="false" [isLoading]="false"
                  [leadAdornment]="false" [trailAdornment]="false" [customColor]="buttonPrimaryColor" [customTextColor]="buttonPrimaryColor"></sync-button>
                <a href="" class="sample-link" [style.color]="linkTextColor">Sample Link</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </sync-dialog>
  </div>
  <!-- User can save changes End -->

  <!-- User can reset to default start -->
  <sync-dialog [config]="{
    title: 'Reset to default',
    actionButton: 'Reset',
    cancelButton: 'Cancel',
    onCancelClick: onCancelClick,
    onActionClick: onResetClick,
    isClosable: false
  }" [open]="isResetDefault" [onClose]="onCloseClick">
    <span class="body reset-content">Your uploaded logo will be removed and your customized colors will be changed back to the
      default selection.</span>
  </sync-dialog>
  <!-- User can reset to default end -->